<section aria-label="Task items">
  <h3 class="text-heading">Task items</h3>

  <div *ngIf="error()" class="lm-notice lm-notice--danger">
    {{ error() }}
    <button type="button" class="lm-btn" (click)="load()">Retry</button>
  </div>

  <form class="task-items-add-form" (ngSubmit)="addTaskItem()">
    <label for="task-item-input">Add checklist item</label>
    <div class="task-items-add-input-row">
      <input
        id="task-item-input"
        name="task-item-input"
        type="text"
        maxlength="500"
        [ngModel]="newTaskItemText()"
        (ngModelChange)="setNewTaskItemText($event)"
        placeholder="Add task item..."
      />
      <button type="submit" class="lm-btn lm-btn--primary" [disabled]="adding()">{{ adding() ? 'Adding…' : 'Add' }}</button>
    </div>
  </form>

  <div *ngIf="loading()" class="loading">Loading task items...</div>

  <ul *ngIf="!loading() && sortedTaskItems() as rows" class="task-items-list">
    <li *ngFor="let taskItem of rows" class="lm-row" [class.lm-row--done]="taskItem.done">
      <label class="task-items-item-toggle">
        <input
          type="checkbox"
          [checked]="taskItem.done"
          [disabled]="isSubmitting(taskItem.id)"
          [attr.aria-label]="taskItem.done ? 'Mark item as open' : 'Mark item as done'"
          (change)="toggleDone(taskItem.id, $any($event.target).checked)"
        />
        <span>Done</span>
      </label>
      <input
        class="task-items-item-text"
        type="text"
        maxlength="500"
        [ngModel]="getDraft(taskItem.id)"
        [name]="'task-item-draft-' + taskItem.id"
        (ngModelChange)="setDraft(taskItem.id, $event)"
        (blur)="saveText(taskItem)"
        [disabled]="isSubmitting(taskItem.id)"
      />
      <div class="task-items-item-actions">
        <button type="button" class="lm-btn" (click)="saveText(taskItem)" [disabled]="isSubmitting(taskItem.id)">Save</button>
        <button type="button" class="lm-btn lm-btn--danger" (click)="deleteTaskItem(taskItem.id)" [disabled]="isSubmitting(taskItem.id)">Delete</button>
      </div>
    </li>
    <li *ngIf="rows.length === 0" class="empty">No task items yet.</li>
  </ul>

  <div class="task-items-footer-actions">
    <button type="button" class="lm-btn" (click)="clearDoneTaskItems()" [disabled]="clearingDone() || !hasDone()">
      {{ clearingDone() ? 'Clearing…' : 'Clear done' }}
    </button>
  </div>
</section>
